import { render, staticRenderFns } from "./gBottom.vue?vue&type=template&id=67740610&scoped=true"
import script from "./gBottom.vue?vue&type=script&lang=js"
export * from "./gBottom.vue?vue&type=script&lang=js"
import style0 from "./gBottom.vue?vue&type=style&index=0&id=67740610&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67740610",
  null
  
)

export default component.exports